module.exports = __webpack_public_path__ + "static/media/new1.925ebd0a.png";